import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import FormFieldComponent from './FormFieldComponent';
import { DialogClose } from '@radix-ui/react-dialog';
import { Button } from './ui/button';
import { useUserStore } from '@/stores/user';
import { useAuthLoginPost, UserResponseSchema } from '@brainvaulttech/dgr-react-sdk';
import { toast } from './ui/use-toast';
import { SESSION_DISABLE_TIME } from '@/utils/constant';

const passwordSchema = z.object({
  password: z.string({ message: 'Password is Required' }).min(6, { message: 'Password is Required' }),
});
export function PasswordDialog({
  confirmBtnClick,
  cancelBtnClick,
  warning,
}: {
  confirmBtnClick?: () => void;
  cancelBtnClick?: () => void;
  warning?: boolean;
}) {
  const user = useUserStore((state) => state);
  const form = useForm({
    resolver: zodResolver(passwordSchema),
    mode: 'all',
  });
  const {
    control,
    getValues,
    formState: { isValid },
  } = form;

  const { mutate: login, status } = useAuthLoginPost();

  const saveHandler = () => {
    if (user.user)
      login(
        {
          data: {
            email: (user.user as UserResponseSchema)?.email,
            password: getValues('password') as string,
          },
        },
        {
          onSuccess: () => {
            confirmBtnClick && confirmBtnClick();
            user.setValidateSession({
              status: 'SUCCESS',
              time: Date.now(),
            });
          },
          onError: () => {
            toast({
              variant: 'destructive',
              description: `Incorrect Password, try again after ${SESSION_DISABLE_TIME / 1000 / 60} minutes`,
            });
            user.setValidateSession({
              status: 'FAILED',
              time: Date.now(),
            });
            cancelBtnClick && cancelBtnClick();
          },
        }
      );
  };

  return (
    <Dialog open={true}>
      <DialogContent className="w-[50vw] h-fit overflow-scroll scrollbar-hide">
        <DialogHeader className="flex flex-col gap-6">
          <DialogTitle>Enter Password</DialogTitle>
          <DialogDescription className="flex flex-col text-black gap-6">
            <span>Please enter password to view the information.</span>
            <FormProvider {...form}>
              <FormFieldComponent
                control={control}
                name="password"
                type="password"
                label="Enter Password"
                required
                placeholder="Enter Password"
                maxLength={64}
              />
            </FormProvider>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="justify-end">
          <div className="flex gap-4 ">
            <DialogClose asChild>
              <Button
                size="sm"
                className={`bg-[#fff] border-[1px] border-bordercolor font-medium text-primary py-2 px-4 rounded-md w-24 hover:bg-[#EDF5FF]  focus:outline-none focus-visible:outline-none`}
                onClick={cancelBtnClick}
              >
                Cancel
              </Button>
            </DialogClose>
            <Button
              type="button"
              size="sm"
              className={`text-[#fff] py-2 font-medium px-4 rounded-md  ${warning ? 'bg-[#D72222] hover:text-white hover:bg-error' : 'bg-primary hover:bg-[#12375C]  hover:text-white'} w-24  focus:outline-none focus-visible:outline-none`}
              onClick={saveHandler}
              disabled={status === 'pending' || !isValid}
              isLoading={status === 'pending'}
            >
              View
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
